import Crud from './crud'
var crud = new Crud('package-rounting', 'trung chuyển kiện hàng');

const state = {
    ...crud.state,
    selected: {}
};
const getters = {
    ...crud.getters,
};
const actions = {
    ...crud.actions,
};
const mutations = {
    ...crud.mutations,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};